import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import {
  CreateBlogTag,
  DidUpdateBlogPost,
} from '../../../actions/blog.actions';
import { take } from 'rxjs/operators';
import * as fromBlog from '../../../reducers';
import { BlogService } from '../../../../lib/services/blogService';
import {
  BlogCategory,
  BlogPostModel,
  BlogTag,
} from '../../../models/blog-post.model';
import { BlogListingModel } from '../../../models/blog-listing.model';

@Component({
  selector: 'mj-blog-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
})
export class InfoComponent implements OnInit, OnDestroy {
  blogState$: Subscription;
  blog_categories$: Observable<Array<BlogCategory>>;
  blog_tags$: Observable<Array<BlogTag>>;
  listing$: Observable<BlogListingModel>;

  constructor(
    private blogService: BlogService,
    private store: Store<fromBlog.State>
  ) {}

  ngOnInit() {
    this.blog_categories$ = this.store.select(fromBlog.selectBlogCategories);
    this.blog_tags$ = this.store.select(fromBlog.selectBlogTags);
    this.listing$ = this.store.select(fromBlog.selectBlogListing);
  }

  ngOnDestroy() {
    if (this.blogState$) {
      this.blogState$.unsubscribe();
    }
  }

  didSelectCategory(category: BlogCategory) {
    this.listing$.pipe(take(1)).subscribe(current_listing => {
      const new_blog_post = current_listing.blog_post;
      new_blog_post.category = category;
      this.updateBlogPost(new_blog_post, current_listing);
    });
  }

  didSelectTag(tag: BlogTag) {
    this.listing$.pipe(take(1)).subscribe(current_listing => {
      const new_blog_post = current_listing.blog_post;
      const isTagInBlogPost = tag_param =>
        new_blog_post.tags.some(({ id }) => id === tag_param);
      if (isTagInBlogPost(tag.id)) {
        /*
                Don't need to remove it even tho it exists
                new_blog_post.tags = new_blog_post.tags.filter((old_tag) => old_tag.id !== tag.id);
                this.store.dispatch(new DidUpdateBlogPost({blog_post: new_blog_post}));
                */
      } else {
        new_blog_post.tags = [...new_blog_post.tags, tag];
        this.updateBlogPost(new_blog_post, current_listing);
      }
    });
  }

  didAddTag(tag: BlogTag) {
    this.store.dispatch(new CreateBlogTag({ tag: tag }));
  }

  didRemoveTag(tag: BlogTag) {
    this.listing$.pipe(take(1)).subscribe(current_listing => {
      const new_blog_post = current_listing.blog_post;
      new_blog_post.tags = new_blog_post.tags.filter(
        old_tag => old_tag.id !== tag.id
      );
      this.updateBlogPost(new_blog_post, current_listing);
    });
  }

  updateBlogPost(new_blog_post: BlogPostModel, listing: BlogListingModel) {
    const new_listing = Object.assign(new BlogListingModel(), listing, {
      blog_post: new_blog_post,
    });
    this.store.dispatch(
      new DidUpdateBlogPost({
        new_listing: new_listing,
        is_valid_blog_info: this.blogService.checkValidBlogInfo(new_blog_post),
      })
    );
  }
}
